import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service" eyebrow="TERMS" lastUpdated="January 2026">
      <p>
        These Terms of Service ("Terms") govern your use of the services
        provided by <strong>Tapped In Clarity</strong>, a sole trader business
        in the United Kingdom ("we", "us", "our"), including the Albetheine
        Oracle mobile application, the online guidebook, psychic medium
        readings, and (once released) Albetheine's Beacon Oracle Deck and
        Albetheine's Shadow Oracle Deck. By accessing or using any of these
        services you agree to be bound by these Terms.
      </p>

      <h2>1. About Us</h2>
      <p>
        Tapped In Clarity is operated as a sole trader business in the United
        Kingdom. Our business address is available on written request. You can
        contact us at{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least 18 years old to purchase or use any of our
        services. By using our services you confirm you are 18 or over.
      </p>

      <h2>3. Our Offerings</h2>
      <ul>
        <li>
          <strong>Albetheine Oracle App</strong> — subscription access at{" "}
          <strong>£9.99 every 3 months</strong>, including seven free single-card
          pulls on sign-up.
        </li>
        <li>
          <strong>The Online Guidebook</strong> — one-time purchase at{" "}
          <strong>£27</strong> for lifetime online access.
        </li>
        <li>
          <strong>Guidebook + 3 Months App Bundle</strong> —{" "}
          <strong>£34.99</strong> one-time.
        </li>
        <li>
          <strong>Online Psychic Medium Readings</strong> —{" "}
          <strong>£150 per 60-minute session</strong>.
        </li>
        <li>
          <strong>Albetheine&apos;s Beacon &amp; Shadow Oracle Decks</strong> — physical
          print-on-demand products, coming soon. Pricing announced at release.
        </li>
        <li>
          <strong>Albetheine Merchandise</strong> — may be offered in the future.
        </li>
      </ul>

      <h2>4. Subscriptions &amp; Recurring Payments</h2>
      <p>
        The Albetheine Oracle App is sold as a recurring subscription billed
        every 3 months at £9.99 until cancelled. You may cancel at any time
        through your account or by emailing us — see our{" "}
        <a href="/cancellation">Cancellation Policy</a>.
      </p>

      <h2>5. Spiritual Services Disclaimer</h2>
      <p>
        Psychic medium readings and oracle content are offered for{" "}
        <strong>guidance, reflection and entertainment purposes only</strong>.
        They are <strong>not</strong> a substitute for professional medical,
        psychological, legal, financial or other qualified advice. You remain
        responsible for your own decisions.
      </p>
      <p>
        Tapped In Clarity does not guarantee any specific outcome from a reading
        or from using Albetheine&apos;s Oracle.
      </p>

      <h2>6. Acceptable Use</h2>
      <ul>
        <li>Do not share, resell or redistribute the app, guidebook or decks.</li>
        <li>Do not attempt to reverse-engineer, copy or scrape the service.</li>
        <li>Do not use the service for any unlawful or abusive purpose.</li>
        <li>Treat readers and staff with respect during sessions.</li>
      </ul>

      <h2>7. Intellectual Property</h2>
      <p>
        All artwork, text, card meanings, guidebook content, branding and the
        Albetheine&apos;s system itself are the intellectual property of Tapped In
        Clarity and are protected by UK and international copyright. You are
        granted a personal, non-transferable licence to use them for your own
        spiritual practice only.
      </p>

      <h2>8. Pricing &amp; Payments</h2>
      <p>
        All prices are in pounds sterling (GBP) and are inclusive of any
        applicable taxes unless stated otherwise. Payments are processed
        securely through Stripe.
      </p>

      <h2>9. Refunds, Cancellations &amp; Disputes</h2>
      <p>
        Please see the dedicated pages: <a href="/refund">Refund Policy</a>,{" "}
        <a href="/cancellation">Cancellation Policy</a>,{" "}
        <a href="/dispute">Dispute &amp; Chargeback Policy</a> and{" "}
        <a href="/shipping">Shipping &amp; Delivery</a>.
      </p>

      <h2>10. Account Suspension</h2>
      <p>
        We may suspend or terminate access to the service if you breach these
        Terms or behave in a way that is abusive or harmful to readers, staff or
        other users.
      </p>

      <h2>11. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Tapped In Clarity's total
        liability arising from or in connection with the services is limited to
        the amount you have paid us in the 12 months preceding the claim.
        Nothing in these Terms limits liability for fraud, death or personal
        injury caused by negligence, or any other liability that cannot be
        limited under UK law.
      </p>

      <h2>12. Changes</h2>
      <p>
        We may update these Terms from time to time. Material changes will be
        notified by email or in-app. Continued use of the service after changes
        means you accept the updated Terms.
      </p>

      <h2>13. Governing Law</h2>
      <p>
        These Terms are governed by the laws of England and Wales, and the
        courts of England and Wales shall have exclusive jurisdiction over any
        dispute.
      </p>

      <h2>14. Contact</h2>
      <p>
        Any question about these Terms can be sent to{" "}
        <a href="mailto:tappedinclarity@gmail.com">tappedinclarity@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
